module.exports = __webpack_public_path__ + "img/rail.6c0cc662.svg";